"use client";

import { Link } from "@/i18n/navigation";
import { parseHairShortlist, hairFinderUrl } from "@/lib/hairFinderHandoff";
import { trackGizmo } from "@/lib/analytics";
import styles from "./hairShadeShortlist.module.css";

export default function HairShadeShortlist({ ids, source, notes }: {
  ids: string[]; source: string; notes: string[];
}) {
  const shades = parseHairShortlist(ids.join(","));
  const download = () => {
    const text = `My hair color comparison\n\n${shades.map((shade, index) => `${shade.name}: ${notes[index] || "A color direction to compare."}`).join("\n\n")}\n\nQuestions for my colorist:\n- How does my current color affect this result?\n- What upkeep and grow-out should I expect?\n- Can we compare a strand or swatch before committing?\n\nIllustrative color directions, not a dye formula.\nhttps://www.coloranalysistech.com${hairFinderUrl(ids)}\n`;
    const url = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
    const a = document.createElement("a");
    a.href = url; a.download = "hair-color-shortlist.txt";
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    trackGizmo("hair_guide_save", { source });
  };
  return <div className={styles.shortlist}>
    <div className={styles.grid}>{shades.map((shade, index) => <article key={shade.id} className={styles.card}>
      <div className={styles.swatch} style={{ background: shade.hex }} aria-hidden="true" />
      <div className={styles.copy}><h3>{shade.name}</h3><p>{notes[index]}</p>
        <Link href={hairFinderUrl(ids, shade.id)} onClick={() => trackGizmo("hair_guide_try", { source, shade: shade.id })}>Try this shade on my photo →</Link>
      </div>
    </article>)}</div>
    <div className={styles.footer}><span>Illustrative swatches. Compare on the same photo before choosing.</span><button type="button" onClick={download}>Save this shortlist for my stylist ↓</button></div>
  </div>;
}
